
import ProductListComponent from "../../../components/products/Index.vue";

export default {
  name: 'ProductIndex',
  components: {
    ProductListComponent
  }
}
